import React from 'react'
import { Translate } from '../../../language'
import { NextIcon, PlusIcon, OilCounterIcon, CoralOnlyIcon } from '../../../assets/icons'
import StoryCell from '../../../utils/components/StoryCell/StoryCell'
import './StoryBar.css'
import localStorage from '../../../utils/hooks/useLocalStorage'
import { useHistory } from "react-router-dom";


const StoryBar = ({
    currenSubStory,
    setCurrenSubStory,
    stories = [],
    handleNewStory = () => { },
    handleViewStory = () => { },
    setCurrenStoryView = () => { },
}) => {

    const history = useHistory()

    return (
        <div className="content-story-bar">
            <NextIcon className="cls-back-next back-svg" height="25" width="25" />
            <div className="content-data-story-bar scroll-menu">
                {/* <StoryCell
                    icon={<CoralOnlyIcon className={`live-icon-history-cell`} />}
                    handleClick={(e) => console.log()}
                    type="live"
                    text={Translate('createLive', 'es')} /> */}
                {
                    //TodoEcoCeoSocial
                    localStorage().getItem("typeProfile") != "warehouse" && <StoryCell
                        icon={<OilCounterIcon className={`oil-counter-icon-history-cell`} />}
                        handleClick={() => history.push('/OilCounter')}
                        type="counter-oil"
                        text={'Contador de aceite'}
                    />
                }
                {
                    localStorage().getItem("typeProfile") != "warehouse" && <StoryCell
                        icon={<PlusIcon className={`plus-icon-history-cell`} />}
                        handleClick={(e) => handleNewStory(true)}
                        type="first"
                        text={Translate('createStory', 'es')}
                    />
                }
                {stories.map((story, index) =>
                    <StoryCell
                        key={index}
                        typeUrl={story.type}
                        imgTumblr={story.url}
                        handleClick={() => {
                            setCurrenSubStory(0)
                            setCurrenStoryView(index)
                            handleViewStory(true)
                        }}
                        imgUrl={story.picture && story.picture.url ? story.picture.url.small : story.picture}
                        text={`${story.name?.split(' ')[0]}  ${story.name?.split(' ')[1] ? story.name?.split(' ')[1] : ''}`} />
                )}
            </div>
            <NextIcon className="cls-back-next" height="25" width="25" />
        </div>
    )
}

export default StoryBar
